// extracted by mini-css-extract-plugin
module.exports = {"gameLogo":"game-logo_gameLogo__3LTdy","byHeight":"game-logo_byHeight__289ht"};